<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('projectManagement.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('projectManagement.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div style="min-height: 80vh;">
          <div class="row">
            <div class="col-md-4">
              <h1
                class="ts-uppercase ts-font-robot ts-text-base ts-text-yellow-700"
              >
                <span><i class="fas fa-user-edit"></i></span>
                {{ $t('projectManagement.mySummary') }}
              </h1>
              <br />
              <div
                class="ts-pl-4 ts-pr-6 ts-py-4 ts-w-full ts-border ts-border-dashed ts-rounded ts-space-y-4"
              >
                <SummaryCardList
                  :title="$t('projectManagement.pendingTask')"
                  bgBadgeColor="ts-bg-blue-500"
                  :numberTask="totalTask"
                />
                <SummaryCardList
                  :title="$t('projectManagement.dailyReport')"
                  :numberTask="0"
                />
                <SummaryCardList
                  :title="$t('projectManagement.pendingRequest')"
                  bgBadgeColor="ts-bg-yellow-500"
                  :numberTask="0"
                />
              </div>
            </div>
            <div class="col-md-8">
              <div class="ts-flex ts-justify-between ts-items-center">
                <h1
                  class="ts-uppercase ts-font-robot ts-text-base ts-text-blue-500"
                >
                  <span><i class="fas fa-file-signature"></i></span>
                  {{ $t('projectManagement.myTask') }} {{ totalTask }}
                </h1>
                <div class="ts-space-x-3">
                  <button
                    @click.prevent="$router.push({ name: 'task-create' })"
                    style="padding: 5px 18px;"
                    class="ts-bg-blue-600 ts-rounded-md ts-text-white"
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                  <button
                    @click.prevent="goTaskList"
                    style="padding: 5px 18px;"
                    class="ts-bg-gray-400 ts-rounded-md ts-text-black"
                  >
                    {{ $t('projectManagement.showAll') }}
                  </button>
                </div>
              </div>
              <br />
              <div
                class="ts-p-4 ts-w-full ts-border ts-border-dashed ts-rounded ts-space-y-3"
              >
                <div
                  class="ts-flex ts-justify-between ts-border-b ts-border-dashed row-task ts-cursor-pointer hover:ts-bg-gray-200 ts-px-4"
                  v-for="(task, index) in tasks"
                  :key="index"
                  @click.prevent="onViewTask(task)"
                >
                  <div>
                    <h4
                      class="ts-text-lg ts-tracking-wide ts-text-blue-700 ts-font-koulens ts-font-robot"
                    >
                      {{ task.title }}
                    </h4>
                    <p class="ts-mb-0">PROJECT: {{ task.project_name }}</p>
                    <p class="ts-mb-0">Site Name: {{ task.milestone_name }}</p>
                  </div>
                  <div class="ts-relative">
                    <div
                      class="ts-flex ts-space-x-3 ts-text-yellow-700"
                      v-if="task.estimate_end_date"
                    >
                      <p>{{ task.estimate_start_date }}</p>
                      <i class="fas fa-long-arrow-alt-right"></i>
                      <p>{{ task.estimate_end_date }}</p>
                    </div>
                    <button
                      @click.prevent="updateColumnValueWhenChange(task)"
                      class="close-btn ts-bg-gray-700 ts-px-4 ts-py-1 ts-text-white ts-text-base ts-rounded-md
                        ts-absolute ts-right-0 ts-top-0 ts-mt-4 ts-font-robot"
                    >
                      {{ $t('close') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SummaryCardList from './components/summary-card-list.vue'
export default {
  components: {
    SummaryCardList
  },
  data() {
    return {
      loading: false,
      totalTask: 0,
      tasks: []
    }
  },
  created() {
    this.fetchTask()
  },
  methods: {
    ...mapActions('projectMgt/home', ['getTask']),
    ...mapActions('projectMgt/taskProfile', ['updateColumnValue']),
    fetchTask() {
      this.loading = true
      this.getTask()
        .then(response => {
          this.tasks = response.task
          this.totalTask = response.task_count
        })
        .finally(() => (this.loading = false))
    },
    goTaskList() {
      localStorage.setItem('only_my_task', JSON.stringify(true))
      localStorage.setItem('involve_task', JSON.stringify(false))
      localStorage.setItem('created_by_me', JSON.stringify(false))
      this.$store.state.projectMgt.taskProfile.only_my_task = true
      this.$store.state.projectMgt.taskProfile.involve_task = false
      this.$store.state.projectMgt.taskProfile.created_by_me = false

      this.$router.push({ name: 'task' })
    },
    updateColumnValueWhenChange(row) {
      this.loading = true
      let model = {
        status_id: 3 // update to completed
      }
      this.updateColumnValue({
        id: row.id,
        data: model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchTask()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onViewTask(record) {
      this.$router.push({
        name: 'task-view',
        params: {
          id: record.id
        }
      })
    }
  }
}
</script>

<style scoped>
.close-btn {
  display: none !important;
}
.row-task:hover .close-btn {
  display: block !important;
}
</style>
